import styled from "styled-components";
import {LinkToOfferBoxBase} from "../link-to-offer-base/link-to-offer-box-base";

export const LinkToOfferDialogCloseDefaultBox = styled(LinkToOfferBoxBase)<{zIndex?: number}>`
    color: ${({theme}) => theme.colors.textDark};
    z-index: ${props => props.zIndex ?? 201};
`;
